/**
 * 텍스트 라벨 사이즈
 * [fontSize, lineHeight, weight]
 */
export const textTagSize = {
  small: ["13px", "18px", 700],
  medium: ["14px", "20px", 700],
  large: ["15px", "20px", 700],
};
